import PropTypes from "prop-types";

import { assetUrl } from "../utils";
import OAuthButton from "./oauth_button";

const OAuthButtons = ({
  authenticityToken,
  googlePath,
  microsoftPath,
  googleLabel = "Continue with Google",
  microsoftLabel = "Continue with Microsoft",
  googleTooltip,
  microsoftTooltip,
}) => (
  <div className="auth-sso-group">
    <OAuthButton
      action={googlePath}
      label={googleLabel}
      tooltipTitle="Sign in with Google"
      tooltipBody={googleTooltip}
      iconSrc={assetUrl("Google_Suite.png")}
      authenticityToken={authenticityToken}
    />

    <div className="mt12">
      <OAuthButton
        action={microsoftPath}
        label={microsoftLabel}
        tooltipTitle="Sign in with Microsoft"
        tooltipBody={microsoftTooltip}
        iconSrc={assetUrl("microsoft_icon.png")}
        authenticityToken={authenticityToken}
      />
    </div>
  </div>
);

OAuthButtons.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  googlePath: PropTypes.string.isRequired,
  microsoftPath: PropTypes.string.isRequired,
  googleLabel: PropTypes.string,
  microsoftLabel: PropTypes.string,
  googleTooltip: PropTypes.string.isRequired,
  microsoftTooltip: PropTypes.string.isRequired,
};

export default OAuthButtons;
